import { Lock, LockOpen, LockReset } from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CustomButton from '../../common/button/commonButton';
import ReusableFormFields from '../../common/textfield/ReusableTextfield';
import { styles } from '../../commonStyle/formStyles';
import HospitalDialog from '../../common/dialog/commonDialogBox';
import {
  changePasswordRequest,
  authResetState,
} from '../../redux/auth/authActions';

function PasswordResetPage() {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const { success, error, errorMessage, inProgress, errormessage, message } =
    useSelector((state) => state.auth?.changePassword || {});

  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
    if (isSuccess) {
      navigate(-1);
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (error) {
      clearErrors();

      if (errorMessage === 'Enter the correct password !') {
        setError('current_password', {
          type: 'manual',
          message: 'Enter the correct password !',
        });
      } else {
        setDialogMessage(errorMessage || errormessage || message || error);
        setIsSuccess(false);
        setOpenDialog(true);
      }

      dispatch(authResetState());
    }

    if (success) {
      setDialogMessage('Password updated successfully!');
      setIsSuccess(true);
      setOpenDialog(true);

      setTimeout(() => {
        reset();
        dispatch(authResetState());
      }, 1000);
    }
  }, [
    error,
    errorMessage,
    errormessage,
    message,
    success,
    setError,
    clearErrors,
    reset,
    dispatch,
  ]);

  const onSubmit = (data) => {
    dispatch(changePasswordRequest(data));
  };

  const inputFields = [
    {
      name: 'current_password',
      label: 'Original Password',
      placeholder: 'Enter original password',
      maxLength: 10,
      showCharCount: false,
      type: 'password',
      startIcon: <Lock />,
      rules: { required: 'Original password is required' },
    },
    {
      name: 'new_password',
      label: 'New Password',
      placeholder: 'Enter new password',
      maxLength: 10,
      showCharCount: false,
      type: 'password',
      startIcon: <LockOpen />,
      rules: { required: 'New password is required' },
    },
    {
      name: 'confirm_password',
      label: 'Confirm Password',
      placeholder: 'Confirm new password',
      maxLength: 10,
      showCharCount: false,
      type: 'password',
      startIcon: <LockReset />,
      rules: { required: 'Password confirmation is required' },
    },
  ];

  return (
    <Box sx={styles.container}>
      <Paper sx={styles.paper} elevation={2}>
        <Typography variant="h5" sx={styles.heading}>
          Reset Password
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <ReusableFormFields
            inputFields={inputFields}
            register={register}
            errors={errors}
            setValue={setValue}
            gridProps={{ sm: 7 }}
            control={control}
          />

          <Box sx={styles.buttonsContainer}>
            <CustomButton
              type="button"
              text="Cancel"
              variant="contained"
              disableElevation
              size="small"
              onClick={() => reset()}
            />
            <CustomButton
              type="submit"
              text="Submit"
              variant="contained"
              disableElevation
              size="small"
              disabled={inProgress}
              loading={inProgress}
            />
          </Box>
        </form>
      </Paper>

      <HospitalDialog
        open={openDialog}
        onClose={handleCloseDialog}
        isSuccess={isSuccess}
        dialogMessage={dialogMessage}
        title={isSuccess ? 'Success' : 'Error'}
      />
    </Box>
  );
}

export default PasswordResetPage;
